import React from "react"
import styles from "../styles/components/title.module.scss"
export default ({ text, as: Heading = "h2" }) => {
  const words = text.split(" ")
  const accent = words.pop()
  return (
    <div>
      <Heading className={styles.text}>
        {words.join(" ")}
        {words.length > 0 && " "}
        <span>{accent}</span>
      </Heading>
    </div>
  )
}
